import styled from "styled-components"

interface Props {
  completed: boolean
}

export const StatusDot = styled.div<Props>`
  position: relative;
  width: 24px;
  height: 24px;
  border: 1px solid ${({theme}) => theme.colors.primary2};
  background: ${({completed, theme}) => (completed ? theme.colors.primary2 : theme.colors.greys.mediumLight)};
  border-radius: 100px;
`

export const Line = styled.div<Props>`
  position: relative;
  height: 2px;
  width: 210px;
  top: 10px;
  background: ${({completed, theme}) => (completed ? theme.colors.primary2 : theme.colors.greys.mediumLight)};
`

export const Relative = styled.div`
  position: relative;
`

export const Absolute = styled.div`
  position: absolute;
  width: 150px;
  top: 25px;
  left: -60px;
  text-align: center;
`
